import React from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
} from "react-native";
import { Color, globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import { Icon } from '@iconify/react';

const BackgroundHeaderCard = ({
  pageTitle,
  customStyle = "",
  customStyleTitle = "",
  onShareClick,
  backButtonHandle,
  title,
  link,
  isEditIconShow = false,
  onConfirmationChangeScreen,
}) => {
  return (
    <View style={styles.clubHeader}>
      <TouchableOpacity onPress={backButtonHandle}>
        <Icon
          icon="tabler:arrow-left"
          style={styles.backStyle}
          color="#FFFFFF"
          width="24"
          height="24"
        />
      </TouchableOpacity>

      <Text style={styles.clubTitleStyle}>{pageTitle}</Text>
      {!pageTitle ? (
        <TouchableOpacity onPress={onShareClick} style={{ padding: 5 }}>
          <Icon
            icon="tabler:share-2"
            style={styles.shareStyle}
            color="#FFFFFF"
            width="24"
            height="24"
          />
        </TouchableOpacity>
      ) : (
        <Text></Text>
      )}
      {isEditIconShow && (
        <TouchableOpacity
          onPress={onConfirmationChangeScreen}
          style={{ flexDirection: "row" }}
        >
          <Icon
            icon="tabler:edit"
            width="16"
            height="16"
            color="#D3D3D3"
          />
          <Text style={{ color: "#D3D3D3" }}> Edit</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

export default BackgroundHeaderCard;

const styles = StyleSheet.create({
  clubHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  backStyle: {
    width: 24,
    height: 24,
  },
  shareStyle: {
    width: 24,
    height: 24,
  },
  clubTitleStyle: {
    ...globalFontStyle.appFontHeading,
    color: Colors.bgWhite,
  },
});
